export default "__VITE_ASSET__f7pE5cmv__"